// removed by extract-text-webpack-plugin
module.exports = {"sizeMD":"16px","attributesLineHeight":"1.8","icon":"Gb4cf86","description":"Ge45553 G791d2a G50d90f Gd71c60","attribute":"G7680af"};